/**
 * Effect of a matching condition inside a condition set (cp.ProvisionAssignmentCondition).
 * INCLUDE: a matching condition makes the assignment apply. EXCLUDE: a matching condition makes the
 * assignment NOT apply; evaluation moves on to the next assignment.
 *
 * Position-based mirror of the backend enum
 * {@code com.mvs.backend.cp.enums.ProvisionAssignmentConditionMode}. The backend persists the
 * ordinal, so the declaration order below MUST match the backend exactly and new constants MUST
 * only be appended at the end.
 *
 * Labels: INCLUDE = "Einschließen" (green, fa-plus), EXCLUDE = "Ausschließen" (red, fa-minus).
 */
export enum ProvisionAssignmentConditionMode {

    INCLUDE,
    EXCLUDE
}
